import { setLocaleOnClient } from '@little-tavern/shared/src/i18n/client'
import updateSetting from '@share/src/module/updateSetting'

const change = async (l: string, pathname: string, lang: string, request: any, auth: any, t: any, isLogin = true) => {
    const params = new URLSearchParams(location.search);
    params.set('reload', '1');
    // setLocaleOnClient(l)
    if (isLogin) {
      // 只有登录用户才更新设置
      const res = await updateSetting({
        data: {
          language: l
        },
        request,
        auth,
        t
      })
      // 切换语言后，重新刷新页面，重置状态
      res && location.replace(pathname.replace(lang, l) + `?${params.toString()}`)
    } else {
      location.replace(pathname.replace(lang, l) + `?${params.toString()}`)
    }
}

export default change;